module.exports = __webpack_public_path__ + "images/feature/1218_doc_md_3-9181fb6d1ab1bb9a72769ecc25e6de71.jpg";